import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import React, { useEffect } from 'react'

interface Props {
    selectedValue?: string;
    onValueChange?: (value: string | undefined) => void;
}

const SelectPosition = ({ selectedValue, onValueChange }: Props) => {
    const [value, setValue] = React.useState<string | undefined>(selectedValue)

    const handleChange = (v: string) => {
        if(v === value) {
            setValue(undefined)
            onValueChange?.(undefined)
        } else {
            setValue(v)
            onValueChange?.(v)
        }
    }

    useEffect(()=>{
        if(!selectedValue) return;
        if(value !== selectedValue) {
            setValue(selectedValue)
        }
    }, [selectedValue])

    return (
        <Select value={value} onValueChange={handleChange}>
            <SelectTrigger><SelectValue placeholder='Selecteer'/></SelectTrigger>
            <SelectContent>
                <SelectItem value="gk">GK</SelectItem>
                <SelectItem value="rb">RB</SelectItem>
                <SelectItem value="lb">LB</SelectItem>
                <SelectItem value="cb">CB</SelectItem>
                <SelectItem value="wbr">WBR</SelectItem>
                <SelectItem value="wbl">WBL</SelectItem>
                <SelectItem value="dm">DM</SelectItem>
                <SelectItem value="cm">CM</SelectItem>
                <SelectItem value="acm">ACM</SelectItem>
                <SelectItem value="w">W</SelectItem>
                <SelectItem value="fw">FW</SelectItem>
            </SelectContent>
        </Select>
    )
}

export default SelectPosition